'use strict';

angular.module('pmtPlacesApp.services').service('GlobalImageService', [
	'$http',
	'pmtSiteInfoService',
	function ($http, pmtSiteInfoService) {
		const setImage = function (setType) {
			return function (place, site, network, type) {
				const url =
					'api/' +
					site.name +
					'/place/' +
					place._id +
					'/image/' +
					network +
					'/' +
					type +
					'/' +
					setType;
				pmtSiteInfoService.addWork();
				return $http.put(url, {});
			};
		};

		return {
			setBrandImage: setImage('regional'),
			setDefaultImage: setImage('global')
		};
	}
]);
